// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__JYeTW","loader":"Loader_loader__pvYRd"};